import { isOwnSiteUri } from '../core/intelligence/grounding-url.js'
import { isBusinessRegistryHost } from './identity-bound-sources.js'

/** A URL with no path and no query. brreg.no/ and proff.no/ are this shape. */
export function isBareHomepage(url: string): boolean {
  try {
    const parsed = new URL(url)
    if (parsed.search) return false
    return parsed.pathname.replace(/\/+$/, '') === ''
  } catch {
    return false
  }
}

export function urlHost(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./i, '').toLowerCase()
  } catch {
    return ''
  }
}

function isOwnDomain(url: string, domain: string | null | undefined): boolean {
  const own = (domain ?? '').replace(/^www\./i, '').toLowerCase().trim()
  if (!own) return false
  const host = urlHost(url)
  return host === own || host.endsWith(`.${own}`)
}

/**
 * A page that can stand behind a sentence.
 * A bare home page counts only for the visitor's own domain, or when the
 * question names that host. Registry home pages do not.
 */
export function citationSupportsQuestion(
  url: string,
  options?: { ownDomain?: string | null; query?: string | null },
): boolean {
  const trimmed = url.trim()
  if (!trimmed) return false
  if (isOwnSiteUri(trimmed)) return false
  if (isBusinessRegistryHost(urlHost(trimmed))) return false
  if (!isBareHomepage(trimmed)) return true
  if (isOwnDomain(trimmed, options?.ownDomain)) return true
  const query = (options?.query ?? '').toLowerCase()
  const host = urlHost(trimmed)
  if (!host || !query) return false
  return query.includes(host)
}

export function spokenSourceCount(
  urls: readonly string[],
  ownDomain?: string | null,
): number {
  const options = ownDomain ? { ownDomain } : {}
  return urls.filter(url => citationSupportsQuestion(url, options)).length
}
